module.exports = __webpack_public_path__ + "static/media/auth-ezycomp-white.f4fde7da.png";